<div class="actual-working-hours-dialog">
  <div class="awh-header">
    <div class="awh-header-text">
      <h2 mat-dialog-title>Saisir les horaires réels de travail</h2>
      <div class="awh-mission-meta" *ngIf="establishmentName || missionReference">
        <span *ngIf="missionReference" class="meta-chip ref">{{ missionReference }}</span>
        <span *ngIf="establishmentName" class="meta-chip">{{ establishmentName }}</span>
        <span *ngIf="serviceName" class="meta-chip">{{ serviceName }}</span>
      </div>
    </div>
    <!-- E4 : statut visible côté pro (En attente / Validé / Refusé) -->
    <span class="status-chip" [ngClass]="data.status">Statut : {{ statusLabel() }}</span>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Chargement des horaires...</p>
  </div>

  <form [formGroup]="workingHoursForm" *ngIf="!isLoading">
    <mat-dialog-content class="awh-content">
      <div *ngIf="data.status !== 'DRAFT'" class="sent-hours-info">
        <span class="sent-icon">ℹ️</span>
        <p>Les heures ont déjà été envoyées pour validation et ne peuvent plus être modifiées.</p>
      </div>

      <div formArrayName="dailyWorkingHours" [hidden]="data.status !== 'DRAFT'">
        <!-- Vue tableau : une ligne par jour — début / fin / pause -->
        <div class="hours-table">
          <div class="hours-row hours-head">
            <div>Jour</div>
            <div>Début</div>
            <div>Fin</div>
            <div>Pause (min)</div>
          </div>
          <div *ngFor="let day of dailyWorkingHours.controls; let i = index" [formGroupName]="i"
            class="hours-row hours-data">
            <div class="day-col">
              <span class="day-name">{{ getFormattedDate(missionDates[i]) }}</span>
            </div>
            <div>
              <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
                <input matInput type="time" formControlName="actualStartTime" required>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic">
                <input matInput type="time" formControlName="actualEndTime" required>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="compact-field compact-number" subscriptSizing="dynamic">
                <input matInput type="number" formControlName="actualPauseMinutes" min="0" max="480" step="5">
              </mat-form-field>
            </div>
            <!-- E3 : valeur d'origine affichée sous le champ modifié -->
            <div class="original-values" *ngIf="isModified(i, 'actualStartTime') || isModified(i, 'actualEndTime') || isModified(i, 'actualPauseMinutes')">
              <span *ngIf="isModified(i, 'actualStartTime')">Valeur d'origine (début) : {{ day.get('originalStartTime')?.value }}</span>
              <span *ngIf="isModified(i, 'actualEndTime')">Valeur d'origine (fin) : {{ day.get('originalEndTime')?.value }}</span>
              <span *ngIf="isModified(i, 'actualPauseMinutes')">Valeur d'origine (pause) : {{ (day.get('originalPauseMinutes')?.value ?? 0) || 0 }} min</span>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="awh-actions">
      <button mat-button type="button" (click)="onCancel()">Annuler</button>
      <button mat-raised-button color="primary" (click)="onSubmit(false)"
        [disabled]="!workingHoursForm.valid || data.status !== 'DRAFT'">
        Enregistrer en brouillon
      </button>
      <button mat-raised-button color="accent" (click)="onSubmit(true)"
        [disabled]="!workingHoursForm.valid || data.status !== 'DRAFT'">
        Signer et envoyer
      </button>
    </mat-dialog-actions>
  </form>
</div>
